import React from "react"
import { Helmet } from "react-helmet"
import Navbar from "../skeleton/navbar"
import Footbar from "../skeleton/footbar"
import BodyInjections from "../injections/bodyInjections"
import HeadInjections from "../injections/headInjections"

//import { withPrefix, Link } from "gatsby"
// <script src={withPrefix('clockbox.js')} type="text/javascript" />
export default function LayoutSite({ children }) {
    return (
      <>
        <Helmet>
          <HeadInjections />          
        </Helmet>
        <div className="site">          
          <Navbar />
          <div className="home">
            <div className="wrap-news-block">
              <div className="container-fluid">
                { children }
              </div>
            </div>
          </div>
          <Footbar />
        </div>
        <BodyInjections />
      </>
    )
  }